








































import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconPlay } from '@/icons';

@Component({
  components: {
    IconPlay,
  },
})
export default class PlayVideoWrapper extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: Number, required: true })
  videoLength!: string

  @Prop(String)
  vimeoId!: string

  @Prop(String)
  youtubeId!: string

  modalOpen = false;

  toggleModalOpen () {
    this.modalOpen = !this.modalOpen;
  }

  get videoLabelId () {
    return `play-video-${this.vimeoId ? this.vimeoId : this.youtubeId}-label`;
  }

  get videoLengthStr () {
    return null;
  }

  get videoThumbnail () {
    if (this.youtubeId)
      return `https://img.youtube.com/vi/${this.youtubeId}/maxresdefault.jpg`;

    return null;
  }
}
